// extracted by mini-css-extract-plugin
module.exports = {"mouse_hover":"ChangeManager_mouse_hover__MOuuI"};